import React from 'react';
import useLoyaltyStore from './useLoyaltyStore';
import CategoryFormModal from './CategoryFormModal';

const CategoriesTab = () => {
  const {
    categories,
    categoriesLoading,
    openModal,
    modalOpen,
    modalType,
    deleteCategory,
  } = useLoyaltyStore();

  const handleEdit = (category) => {
    openModal('category', 'edit', category);
  };

  const handleDelete = (category) => {
    if (window.confirm(`Are you sure you want to delete "${category.name}"?`)) {
      deleteCategory(category.id);
    }
  };

  const handleAdd = () => {
    openModal('category', 'create');
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Categories</h5>
        <button className="btn btn-primary btn-sm" onClick={handleAdd}>
          + Add Category
        </button>
      </div>

      {categoriesLoading ? (
        <div className="text-center py-4">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Icon</th>
              <th>Category Name</th>
              <th>Slug</th>
              <th>Sort Order</th>
              <th>Show in App</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted py-4">
                  No categories found. Add your first category.
                </td>
              </tr>
            ) : (
              categories.map((category) => (
                <tr key={category.id}>
                  <td className="align-middle" style={{ fontSize: 22 }}>
                    {category.icon || '-'}
                  </td>
                  <td className="align-middle">{category.name}</td>
                  <td className="align-middle text-muted">/{category.slug}</td>
                  <td className="align-middle">{category.sort_order ?? '-'}</td>
                  <td className="align-middle">
                    {category.show_in_app ? (
                      <span className="badge badge-success">Yes</span>
                    ) : (
                      <span className="badge badge-danger">No</span>
                    )}
                  </td>
                  <td className="align-middle">
                    <button
                      className="btn btn-sm btn-outline-secondary mr-1"
                      onClick={() => handleEdit(category)}
                      title="Edit"
                    >
                      <i className="zmdi zmdi-edit" />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(category)}
                      title="Delete"
                    >
                      <i className="zmdi zmdi-delete" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {modalOpen && modalType === 'category' && (
        <CategoryFormModal />
      )}
    </div>
  );
};

export default CategoriesTab;
